<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

        <b-row style="margin: 10px 0 30px;">
            <b-col class="p-0">
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="mobile-version-list"
                          class="custom-table-list-pagination" />
            </b-col>

            <transition name="visibility-switch">
                
                <b-col v-if="deletion.length" class="p-0 h-end">

                    <b-button id="mobile-version-delete-btn"
                              class="admin-button mr-10"
                              style="height: 34.8px"
                              @click="deleteMobileVersionDialog" >
                        <font-awesome-icon icon="trash-alt" />
                        Удалить
                    </b-button>

                    <b-button id="admin-btn-cancel"
                            class="m-0 admin-button"
                            style="height: 34.8px"
                            @click="cancel">
                        Отменить
                    </b-button>

                </b-col>

            </transition>

        </b-row>

        <b-table id="mobile-version-list"
                 class="custom-table-list" 
                 responsive="sm"

                 :fields="fields" 
                 :items="mobileVersions" 
                 
                 :per-page="perPage"
                 :current-page="currentPage">

            <template v-slot:cell(IsActive)="data">
                <b-checkbox v-model="data.item.IsActive"
                            class="admin-checkbox"
                            @change="updateMobileVersion(data.item)" />
            </template>

            <template v-slot:cell(IsLastVersion)="data">
                <b-checkbox v-model="lastMobileVersionId"
                            :key="data.item.Id"
                            :value="data.item.Id"
                            class="admin-checkbox"
                            @change="updateMobileVersion"/>
            </template>

            <template v-slot:cell(Delete)="data">

                <b-checkbox v-model="deletion"
                            :value="data.item"
                            class="admin-checkbox red" />
            </template>

        </b-table>

        <b-row id="custom-table-list-pagination-second">
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="mobile-version-list"
                          class="custom-table-list-pagination" />
        </b-row>

    </div>
</template>
<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

export default {
    computed: {
        rows: function() {
            return this.mobileVersions.length;
        }
    },
    data: function() {

        let load = new Loading();

        this.getMobileVersions(load);

        return {
            load: load,            
            mobileVersions: [],
            copyMobileVersions: [],
            lastMobileVersionId: null,

            deletion: [],

            perPage: 30,
            currentPage: 1,

            fields: [
                { 
                    key: 'Version', 
                    label: 'Версия',
                    sortable: true,
                    tdClass: value => {
                        return 'td-pl';
                    },
                    tdAttr: value => {
                        return { width: '40%' };
                    }
                },
                { 
                    key: 'IsActive', 
                    label: 'Создание аудита',
                    tdClass: value => {
                        return 'td-pl';
                    }
                },
                { 
                    key: 'IsLastVersion', 
                    label: 'Последняя версия', 
                    tdClass: value => {
                        return 'td-pl';
                    }
                },
                { 
                    key: 'Delete', 
                    label: 'Удалить версию',
                    tdClass: value => {
                        return 'td-pl';
                    }
                },
            ]
        }
    },
    methods: {
        getMobileVersions: function(load) {
            load.Calculate(true);

            apiService.Admin.MobileVersions.GetAll()
                .then(response => {
                    this.mobileVersions = response.data;
                    this.copyMobileVersions = JSON.parse(JSON.stringify(response.data));
                    this.lastMobileVersionId = this.mobileVersions.find(e => e.IsLastVersion == true).Id;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },
        updateMobileVersion: function(value) {
            this.$nextTick(() => {
                let mobileVersion = value;
            
                if(typeof(value) == 'string') {

                    let id = value;

                    this.mobileVersions.forEach(e => {
                        if(id == e.Id)
                            e.IsLastVersion = true;
                        else
                            e.IsLastVersion = false;
                    });

                    mobileVersion = this.mobileVersions.find(e => e.Id == id);
                }

                this.load.Calculate(true);
                mobileVersion = JSON.parse(JSON.stringify(mobileVersion));

                apiService.Admin.MobileVersions.PostUpdate(mobileVersion)
                    .then(response => {
                        this.$router.go(this.$router.currentRoute);
                    })
                    .catch(error => this.load.Calculate(false));         
            });  
        },
        cancel: function() {
            this.deletion = [];
        },
        deleteMobileVersionDialog: function() {

            let message = "Вы действительно хотите удалить версии ";

            for (let i = 0; i < this.deletion.length; i++) {

                if((i + 1) < this.deletion.length)
                    message += `${this.deletion[i].Version}, `;
                else
                    message += `${this.deletion[i].Version}?`;                
            }

            dialogService.showConfirm('Подтверждение удаления', message)
                .then(ok => {
                    this.deleteMobileVersion(); 
                })
                .catch(cancel => this.cancel());
        },
        deleteMobileVersion: function(item) {            
            let ids = this.deletion.map(e => e.Id);

            this.deletion.forEach(el => {
                let index = this.mobileVersions.findIndex(e => e == el);
                this.mobileVersions.splice(index, 1);
            })

            apiService.Admin.MobileVersions.PostDeleteRange(ids)
                .then(response => {

                    this.copyMobileVersions = JSON.stringify(JSON.parse(this.mobileVersions))
                })
                .catch(error => {
                    
                    this.mobileVersions = JSON.stringify(JSON.parse(this.copyMobileVersions))
                });
        }
    },
    components: {
        Spinner
    }
}
</script>

<style>
.td-pl{
    padding-left: 25px !important;
}
#mobile-version-delete-btn{
    color: white;
    background-color: #EB5757;
}
</style>